"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerGameMinutesParamsSchema = void 0;
const zod_1 = require("zod");
const playerAggregate_1 = require("./playerAggregate");
const playerGameMinutes_1 = require("./playerGameMinutes");
const query_1 = require("./query");
const util_1 = require("./util");
const PlayerGameMinutesRequestSchema = zod_1.z.union((0, util_1.schemaKeys)(zod_1.z.object({
    input: playerAggregate_1.PlayerSequenceAggregateSchema,
    output: playerGameMinutes_1.PlayerGameMinutesWithRelsSchema,
})));
const PlayerGameMinutesWithRelsFieldSchema = zod_1.z.union((0, util_1.schemaKeys)(playerGameMinutes_1.PlayerGameMinutesWithRelsSchema));
exports.PlayerGameMinutesParamsSchema = (0, query_1.filterParamsSchema)(PlayerGameMinutesRequestSchema)
    .extend({
    offset: query_1.OffsetSchema,
    limit: query_1.LimitSchema,
    // Order by only allows keys that are in the response.
    order_by: zod_1.z.record(PlayerGameMinutesWithRelsFieldSchema, query_1.SortOrderSchema).optional(),
})
    .strict();
//# sourceMappingURL=playerGameMinutesQuery.js.map